import styled from "styled-components"

import { Skeleton, Text } from "@minuthq/meatball-ui-react"

import { DataValue } from "src/components/Reports/DataSummary/DataValue"
import { useTranslate } from "src/i18n/useTranslate"
import { Container } from "src/ui/Container/Container"
import { MCard } from "src/ui/MCard/MCard"
import { spacing } from "src/ui/spacing"

export function DataSummary({
  title,
  data,
  isLoading,
  isError,
}: {
  title: React.ReactNode
  data: React.ComponentProps<typeof DataValue>[]
  isLoading?: boolean
  isError?: boolean
}) {
  const { tPlaceholder } = useTranslate()

  function renderValue(value: React.ReactNode) {
    if (isLoading) {
      return <Skeleton width="120px" height="32px" />
    }

    if (isError) {
      return (
        <Text color="emergency" variant="subtitle">
          {tPlaceholder("Error loading data")}
        </Text>
      )
    }

    return value
  }

  return (
    <Container>
      <MCard boxShadow={false} border={true} padding={spacing.L}>
        <Text variant="heading3" marginBottom={spacing.M}>
          {title}
        </Text>

        <DataValueBox>
          {data.map((d) => (
            <Item key={d.description?.toString()}>
              <DataValue
                value={renderValue(d.value)}
                description={d.description}
              />
            </Item>
          ))}
        </DataValueBox>
      </MCard>
    </Container>
  )
}

const DataValueBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing.L};
`

const Item = styled.div`
  flex: max-content;
  min-width: 120px;
`
